import styled from 'styled-components';

import { Card } from '../../../designComponents';

export const ProposalsListingContainerStyled = styled.div`
  margin-top: 18px;

  & .table-container {
    margin-bottom: 20px;
  }
`;

export const IndividualTechnicianProposalStyled = styled(Card)`
  background-color: ${({ theme }) => theme.colors.capriBlue};
  height: auto;
`;
